// EventContextProvider.js
import React, { createContext, useContext, useState, useEffect } from "react";
import { getEvent } from "../../utils/events-utils"; // Adjust the import path as necessary
import PropTypes from "prop-types";

// Create the context with an initial value
const EventContext = createContext({
  eventData: null,
  isLoading: true,
  error: null
});

// Create a custom hook for consuming the context
export const useEvent = () => useContext(EventContext);

// Define the provider component
export const EventContextProvider = ({ children, slug }) => {
  const [eventData, setEventData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEventData = async () => {
      try {
        setIsLoading(true);
        if (window.APP.eventData) {
          setEventData(window.APP.eventData);
        } else {
          const data = await getEvent(slug);
          setEventData(data);
        }
      } catch (err) {
        setError(err);
      } finally {
        setIsLoading(false);
      }
    };

    if (slug) {
      fetchEventData();
    }
  }, [slug]);

  return <EventContext.Provider value={{ eventData, isLoading, error, slug }}>{children}</EventContext.Provider>;
};

EventContextProvider.propTypes = {
  children: PropTypes.node.isRequired, // React elements or components as children
  slug: PropTypes.string // Event slug as a string
};
